import UIBaseComponent from "@baseUI/component/base/UIBaseComponent";

export default class StateButtonComponent extends UIBaseComponent {

  constructor(stateTextures) {
    super()
    this.states = stateTextures
    this.isOut = true
    this.currentState = 0
    this.init()
  }

  init() {

    this.textures = this.getTexturesByNames(this.states)

    this.button = new PIXI.AnimatedSprite(this.textures)
    this.button.on('pointerup', this.onButtonUp, this)

    this.button.buttonMode = true
    this.interactive = true
    this.button.interactive = true

    this.button.anchor.set(0.5)
    this.addChild(this.button)
  }

  onButtonUp (e) {
    this.checkForState()
    let value = this.currentState === 0 ? true : false
    this.emit('tapButton',{value: value})
    //document.dispatchEvent(new CustomEvent('tap', {detail: {name: this.key, value: value, button: this}}))
  }

  checkForState() {
    if(this.currentState + 1 <= this.states.length - 1) {
      this.currentState ++
    } else {
      this.currentState = 0
    }
    this.button.gotoAndStop(this.currentState)
  }

  destroy(options) {
    super.destroy(options)
    this.button.off('pointerup', this.onButtonUp, this)
    this.button.interactive = false
  }

  onSetState(state) {
    this.setValue(state)
  }

  setValue(value) {

    if(value) {
      this.currentState = 0
    } else {
      this.currentState = 1
    }
    this.button.gotoAndStop(this.currentState)
  }

  disable() {
    this.setValue(false)
  }

  enable() {
    this.setValue(true)
  }

  get stateStatus(){
    return this.currentState === 0
  }

  getTexturesByNames(names) {
    let textures = []
    for (let i = 0; i < names.length; i++) {
      textures.push(PIXI.Texture.from(names[i]))
    }
    return textures
  }
}